module.exports = __webpack_public_path__ + "img/swipe (7).33109d14.jpg";